<template>
  <VLoader v-if="videosLoading" />
  <div v-else class="w-full h-full">
    <VideoCards :videos="videos" :serie="serie" @delete="handleDelete" @edit="handleEdit" />

    <!-- Modals -->
    <ModalPlus
      title="Add Section"
      buttonText="Add Section"
      :show="showModal"
      :onClose="handleClose"
      :onProceed="handleSubmit(handleAddSection)"
      :loading="formLoading"
      maxWidth="900px"
    >
      <div class="py-8">
        <!-- pre-training video form -->
        <div>
          <VideoForm :errors="errors" @set="handleSetField" />
        </div>

        <!-- divider -->
        <div class="h-px mx-8 my-6 bg-ricoma-gray-300"></div>

        <!-- pre-training resources form -->
        <div class="mb-6">
          <h3 class="px-8 mb-8 text-sm font-semibold">Resouces</h3>
          <PreTrainingFormResources @update="handleUpdateResources" />
        </div>
        <div>
          <h3 class="px-8 mb-8 text-sm font-semibold">CheckList</h3>
          <PreTrainingFormCheckLists @update="handleUpdateCheckList" />
        </div>
      </div>
    </ModalPlus>
  </div>
</template>

<script>
import { formMixin, videosViewMixin } from '@/mixins';

import VLoader from '@/components/base/VLoader';
import ModalPlus from '@/components/shared/modal/ModalPlus';
import VideoCards from '@/components/admin/VideoCards';
import VideoForm from '@/components/admin/VideoForm';
import PreTrainingFormResources from '@/components/admin/PreTrainingFormResources';
import PreTrainingFormCheckLists from '@/components/admin/PreTrainingFormCheckLists';

export default {
  name: 'AdminPreTrainingView',
  components: {
    VLoader,
    VideoCards,
    VideoForm,
    PreTrainingFormResources,
    PreTrainingFormCheckLists,
    ModalPlus,
  },
  mixins: [
    formMixin(
      { title: '', summary: '', order: '', embed_code: '', thumbnail: null, is_intro_video: false },
      ['is_intro_video', 'thumbnail'],
    ),
    videosViewMixin('pre-training'),
  ],
  watch: {
    async language() {
      this.videos = await this.fetchVideos(this.$http, this.$route.params.id, this.language.code);
    },
  },
  methods: {
    handleUpdateCheckList(checklists) {
      this.checklists = checklists;
    },
    handleUpdateResources(resources) {
      this.resources = resources;
    },
    async handleAddSection(data) {
      const serieId = this.$route.params.id;

      const requestData = {
        ...data,
        group_id: serieId,
        lang_code: this.language.code,
      };

      const formData = new FormData();
      Object.keys(requestData).forEach(key =>
        key === 'is_intro_video'
          ? formData.append(key, requestData[key] ? 1 : 0)
          : formData.append(key, requestData[key]),
      );

      // create new video
      const res = await this.$http.post('/admin/pre-training', formData);
      const video = res.data.data;
      this.videos = [...this.videos, video];

      // create quiz entity for video
      await this.$http.post(`/admin/pre-training/${video.id}/quiz`);

      // create resources for video
      this.resources.forEach(async resource => {
        const formData = new FormData();
        Object.entries(resource).forEach(([key, value]) => formData.append(key, value));
        await this.$http.post(`/admin/pre-training-videos/${video.id}/resources`, formData);
      });

      // create resources for video
      this.checklists.forEach(async checklist => {
        const formData = new FormData();
        Object.entries(checklist).forEach(([key, value]) => formData.append(key, value));
        await this.$http.post(`/admin/pre-training-videos/${video.id}/checklists`, formData);
      });

      this.handleResetFields();
      this.handleClose();
    },
  },
};
</script>
